module.exports = __webpack_public_path__ + "assets/img/thumb-SpinTel-Pillar-Page-Resource.a8d302df.webp";